import { render, staticRenderFns } from "./PmtaSpeedForm.vue?vue&type=template&id=93d5dcf6&scoped=true"
import script from "./PmtaSpeedForm.vue?vue&type=script&lang=js"
export * from "./PmtaSpeedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d5dcf6",
  null
  
)

export default component.exports